import { getSubscriptionProduct } from "../../subscription-product/services/getSubscriptionProduct.js";
import { getContractDeliveryInput } from "../delivery/getContractDeliveryInput.js";
import { resolveBookClubDelivery } from "../delivery/resolveDelivery.js";
import { getProgressionIndex } from "../getMeteredVariables.js";
import { getUsageTracked } from "../queries/getUsageTracked.subscriptions.js";
/**
 * The book club delivery of a contract the caller already holds, resolved from
 * the same facts as `getSubscriptionContractDetails` but with the fewest
 * requests: the product always, the usage only while a sign-up gift campaign
 * has to be told apart from the first main book. For lists of memberships,
 * where the full details would be a request waterfall per card.
 * Undefined when the product is not a book club.
 */
export const getContractBookClubDelivery = async ({ contract }, { client }) => {
    const { gifts: giftConfig, ...product } = await getSubscriptionProduct({ sku: contract.item.sku }, { client });
    if (!product.isBookClub)
        return undefined;
    const withoutUsage = getContractDeliveryInput({
        meta: contract.meta,
        isBookClub: true,
        giftConfig,
        lastReceivedBookSku: undefined,
    });
    // Only a gift campaign whose gifts are not marked received needs the usage,
    // which tells whether a main book went out before the mark was set
    const input = withoutUsage.isGiftCampaign && withoutUsage.isWithoutCreatedOrders
        ? getContractDeliveryInput({
            meta: contract.meta,
            isBookClub: true,
            giftConfig,
            lastReceivedBookSku: getProgressionIndex(await getUsageTracked({ contractId: contract.id }, { client }), product.plan)?.idempotencyKey,
        })
        : withoutUsage;
    return resolveBookClubDelivery({
        dispatches: product.dispatches,
        renewAt: contract.status?.renewAt,
        dispatchBatchCode: input.dispatchBatchCode ?? undefined,
        periodsToSkip: input.periodsToSkip,
        isGiftCampaign: input.isGiftCampaign,
        isWithoutCreatedOrders: input.isWithoutCreatedOrders,
        selectedGiftSkus: input.gifts,
        giftConfig,
    });
};
